import type { ViewName } from './events';

/** Map a pathname to an analytics ViewName. Returns null for unmapped paths. */
export function pathnameToView(pathname: string): ViewName | null {
  if (pathname === '/' || pathname === '/dashboard' || pathname === '/dashboard/') return 'dashboard';
  if (pathname.startsWith('/projects')) return 'projects';
  if (pathname.startsWith('/library')) return 'library';
  if (pathname.startsWith('/tracker')) return 'tracker';
  if (pathname.startsWith('/builder')) return 'builder';
  if (pathname.startsWith('/just-knit')) return 'just_knit';
  if (pathname.startsWith('/ai-import')) return 'ai_import';
  if (pathname.startsWith('/wizard')) return 'wizard';
  if (pathname.startsWith('/settings')) return 'settings';
  return null;
}
